import React, { useState, Fragment, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Dialog, Transition } from "@headlessui/react";
import { customStyles }  from "../Utils/CommonFuntion";
import { formBtn1, formBtn2,inputClass,labelClass} from "../Utils/CustomClasses";
import Error from "../Error/Error";
import { useSelector } from "react-redux";
import Select from "react-select";
import {AddGroupsAPI,AssignUserAPI,UpdateGroupsAPI} from "../../API/Api";
import { toast } from "react-toastify";
import { IconEdit } from "@tabler/icons-react";

export default function AddGroups({Company, filterRecords, edit, row }) {
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const {register,handleSubmit,control,reset,formState: { errors },setValue} = useForm();
  const [isOpenGroup, setIsOpenGroup] = useState(false);
  const [AssignUsers, setAssignUsers] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const toggle = () => {
    setIsOpenGroup(!isOpenGroup);
    reset();
  };

  const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name}`,
        }))
      : [{ value: "", label: "No data found" }];

  const handleAssignChange = async (selectedOption) => {
    try {
      let response = await AssignUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        search: selectedOption,
        company: edit
          ? row?.company?._id
          : UserDetails?.role?.roleName == "Admin"
          ? UserDetails?.company?._id
          : selectedCompanyId,
      });
      setAssignUsers(response?.data?.filteredData);
    } catch (error) {
      console.error("Error assigning user:", error);
    }
  };

  const handleCompanySelect = async (id) => {
    setSelectedCompanyId(id);
    setValue("users", null);
    setAssignUsers([]);
    try {
      let response2 = await AssignUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        company: id,
      });
      setAssignUsers(response2?.data?.filteredData);
    } catch (err) {
      console.log("Error", err);
    }
  };

  const onSubmit = async (data) => {
    const Payload = {
      company:
        UserDetails?.role?.roleName == "Admin"
          ? UserDetails?.company?._id
          : data?.company,
      grpName: data?.grpName,
      users: data?.users?.map((user) => user.value),
    };
    const updatedPayload = {
      grpName: data?.grpName,
      users: data?.users?.map((user) => user.value),
    };
    try {
      let response;
      if (edit) {
        response = await UpdateGroupsAPI(row?._id, updatedPayload);
      } else {
        response = await AddGroupsAPI(Payload);
      }
      if (response.status == 200) {
        toast.success(response?.data?.message);
        toggle();
        setAssignUsers([]);
        filterRecords();
      } else {
        toast.error(response?.response?.data?.error);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    if (UserDetails?.company?.companyName) {
      setValue("company", UserDetails?.company?.companyName);
    }
    if (isOpenGroup && UserDetails?.role?.roleName == "Admin") {
      handleCompanySelect(UserDetails?.company?._id);
    }

    if (edit == true) {
      reset({
        grpName: row?.grpName,
        company: row?.company?.companyName,
        users: row?.users.map((user) => ({
          value: user._id,
          label: `${user?.first_name} ${user?.last_name}`,
        })),
      });
    }
  }, [isOpenGroup]);

  return (
    <>
      <div className="flex gap-4">
        {edit ? (
          <button onClick={toggle}>
           <IconEdit stroke={1.5} size={24} color="#000" />
          </button>
        ) : (
          <button onClick={toggle} className={formBtn1}>
            Add Group
          </button>
        )}
        <Transition appear show={isOpenGroup} as={Fragment}>
          <Dialog as="div" className="relative z-[100]" onClose={toggle}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>
            <div className="fixed inset-0 overflow-y-scroll">
              <div className="flex items-center justify-center min-h-full p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                    <Dialog.Title
                      as="h2"
                      className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                    >
                      {edit ? "Edit Groups" : "Add Group"}
                    </Dialog.Title>
                    <div>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-4">
                          {!edit ? (
                            <div className="grid lg:grid-cols-1 py-1 mx-4">
                              <div className="">
                                {UserDetails?.role?.roleName == "SuperAdmin" ? (
                                  <>
                                    <label className={labelClass}>
                                      Company Name
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      className={`${inputClass}`}
                                      placeholder="Select Company"
                                      {...register("company", {
                                        required: true,
                                      })}
                                      onChange={(e) =>
                                        handleCompanySelect(e.target.value)
                                      }
                                    >
                                      <option value="" disabled>
                                        Select Company
                                      </option>
                                      {Company?.map((data) => (
                                        <option
                                          className="text-black"
                                          key={data?._id}
                                          value={data?._id}
                                        >
                                          {data?.companyName}
                                        </option>
                                      ))}
                                    </select>
                                  </>
                                ) : (
                                  <>
                                    <label className={labelClass}>
                                      Company Name
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={inputClass}
                                      disabled
                                      {...register("company", {
                                        required: true,
                                      })}
                                    />
                                  </>
                                )}
                                {errors.company && (
                                  <Error title="Company ID is Required*" />
                                )}
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="grid lg:grid-cols-1 py-1 mx-4">
                                <label className={labelClass}>
                                  Company Name
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  className={inputClass}
                                  disabled
                                  {...register("company", { required: true })}
                                />
                              </div>
                            </>
                          )}
                          <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                            <div className="">
                              <label className={labelClass}>
                                Group Name
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className={inputClass}
                                {...register("grpName", { required: true })}
                              />
                            </div>
                            <div className="">
                              <label className={labelClass}>
                                Select Users
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              {errors.assign_to && (
                                <Error title={errors.assign_to.message} />
                              )}
                              <div className="form-group">
                                <Controller
                                  name="users"
                                  control={control}
                                  rules={{ required: "assign to is Required*" }}
                                  render={({ field }) => (
                                    <Select
                                      value={field.value || null}
                                      options={assignToOptions}
                                      placeholder="Select User"
                                      isMulti
                                      closeMenuOnSelect={false}
                                      styles={customStyles}
                                      maxMenuHeight={220}
                                      menuPlacement="auto"
                                      onChange={(selectedOption) => {
                                        field.onChange(selectedOption); // Update form state
                                        handleAssignChange(selectedOption); // Call custom function
                                      }}
                                      onInputChange={(
                                        inputValue,
                                        { action }
                                      ) => {
                                        if (action === "input-change") {
                                          handleAssignChange(inputValue); // Call function on typing
                                        }
                                      }}
                                      {...field}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                          <button
                            type="submit"
                            className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                            onClick={toggle}
                          >
                            Close
                          </button>
                        </footer>
                      </form>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
}
